/**
 * Generated by orval v8.12.1 🍺
 * Do not edit manually.
 * Verdi Dashboard API
 * API for the Verdi Dashboard application
 * OpenAPI spec version: 1.0.0
 */

import type {
	DataTag,
	DefinedInitialDataOptions,
	DefinedUseQueryResult,
	MutationFunction,
	QueryClient,
	QueryFunction,
	QueryKey,
	UndefinedInitialDataOptions,
	UseMutationOptions,
	UseMutationResult,
	UseQueryOptions,
	UseQueryResult,
} from "@tanstack/react-query";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { customFetch } from "../custom-fetch";
import type {
	CommandGroup,
	CreateIrrigationEventGroup201,
	CreateIrrigationEventGroup400,
	CreateIrrigationEventGroup500,
	CreateIrrigationEventGroupBody,
	DeleteIrrigationEventGroup400,
	DeleteIrrigationEventGroup404,
	DeleteIrrigationEventGroup500,
	GetIrrigationEventGroup400,
	GetIrrigationEventGroup404,
	GetIrrigationEventGroup500,
	ListIrrigationEventGroups200,
	ListIrrigationEventGroups400,
	ListIrrigationEventGroups500,
	ListIrrigationEventGroupsParams,
} from "./schemas";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

export const getCreateIrrigationEventGroupUrl = () => {
	return `/irrigation-event-groups`;
};

/**
 * @summary Create a group of irrigation events that share a CommandGroup reference
 */
export const createIrrigationEventGroup = async (
	createIrrigationEventGroupBody: CreateIrrigationEventGroupBody,
	options?: RequestInit,
): Promise<CreateIrrigationEventGroup201> => {
	return customFetch<CreateIrrigationEventGroup201>(
		getCreateIrrigationEventGroupUrl(),
		{
			...options,
			method: "POST",
			headers: { "Content-Type": "application/json", ...options?.headers },
			body: JSON.stringify(createIrrigationEventGroupBody),
		},
	);
};

export const getCreateIrrigationEventGroupMutationOptions = <
	TError = CreateIrrigationEventGroup400 | CreateIrrigationEventGroup500,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof createIrrigationEventGroup>>,
		TError,
		{ data: CreateIrrigationEventGroupBody },
		TContext
	>;
	request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof createIrrigationEventGroup>>,
	TError,
	{ data: CreateIrrigationEventGroupBody },
	TContext
> => {
	const mutationKey = ["createIrrigationEventGroup"];
	const { mutation: mutationOptions, request: requestOptions } = options
		? options.mutation &&
			"mutationKey" in options.mutation &&
			options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey }, request: undefined };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof createIrrigationEventGroup>>,
		{ data: CreateIrrigationEventGroupBody }
	> = (props) => {
		const { data } = props ?? {};

		return createIrrigationEventGroup(data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type CreateIrrigationEventGroupMutationResult = NonNullable<
	Awaited<ReturnType<typeof createIrrigationEventGroup>>
>;
export type CreateIrrigationEventGroupMutationBody =
	CreateIrrigationEventGroupBody;
export type CreateIrrigationEventGroupMutationError =
	| CreateIrrigationEventGroup400
	| CreateIrrigationEventGroup500;

/**
 * @summary Create a group of irrigation events that share a CommandGroup reference
 */
export const useCreateIrrigationEventGroup = <
	TError = CreateIrrigationEventGroup400 | CreateIrrigationEventGroup500,
	TContext = unknown,
>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof createIrrigationEventGroup>>,
			TError,
			{ data: CreateIrrigationEventGroupBody },
			TContext
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseMutationResult<
	Awaited<ReturnType<typeof createIrrigationEventGroup>>,
	TError,
	{ data: CreateIrrigationEventGroupBody },
	TContext
> => {
	return useMutation(
		getCreateIrrigationEventGroupMutationOptions(options),
		queryClient,
	);
};
export const getListIrrigationEventGroupsUrl = (
	params?: ListIrrigationEventGroupsParams,
) => {
	const normalizedParams = new URLSearchParams();

	Object.entries(params || {}).forEach(([key, value]) => {
		if (value !== undefined) {
			normalizedParams.append(key, value === null ? "null" : String(value));
		}
	});

	const stringifiedParams = normalizedParams.toString();

	return stringifiedParams.length > 0
		? `/irrigation-event-groups?${stringifiedParams}`
		: `/irrigation-event-groups`;
};

/**
 * @summary List irrigation event groups for the authenticated user, optionally filtered by name or source
 */
export const listIrrigationEventGroups = async (
	params?: ListIrrigationEventGroupsParams,
	options?: RequestInit,
): Promise<ListIrrigationEventGroups200> => {
	return customFetch<ListIrrigationEventGroups200>(
		getListIrrigationEventGroupsUrl(params),
		{
			...options,
			method: "GET",
		},
	);
};

export const getListIrrigationEventGroupsQueryKey = (
	params?: ListIrrigationEventGroupsParams,
) => {
	return ["irrigation-event-groups", ...(params ? [params] : [])] as const;
};

export const getListIrrigationEventGroupsQueryOptions = <
	TData = Awaited<ReturnType<typeof listIrrigationEventGroups>>,
	TError = ListIrrigationEventGroups400 | ListIrrigationEventGroups500,
>(
	params?: ListIrrigationEventGroupsParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listIrrigationEventGroups>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ?? getListIrrigationEventGroupsQueryKey(params);

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof listIrrigationEventGroups>>
	> = ({ signal }) =>
		listIrrigationEventGroups(params, { signal, ...requestOptions });

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof listIrrigationEventGroups>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListIrrigationEventGroupsQueryResult = NonNullable<
	Awaited<ReturnType<typeof listIrrigationEventGroups>>
>;
export type ListIrrigationEventGroupsQueryError =
	| ListIrrigationEventGroups400
	| ListIrrigationEventGroups500;

export function useListIrrigationEventGroups<
	TData = Awaited<ReturnType<typeof listIrrigationEventGroups>>,
	TError = ListIrrigationEventGroups400 | ListIrrigationEventGroups500,
>(
	params: undefined | ListIrrigationEventGroupsParams,
	options: {
		query: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listIrrigationEventGroups>>,
				TError,
				TData
			>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof listIrrigationEventGroups>>,
					TError,
					Awaited<ReturnType<typeof listIrrigationEventGroups>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListIrrigationEventGroups<
	TData = Awaited<ReturnType<typeof listIrrigationEventGroups>>,
	TError = ListIrrigationEventGroups400 | ListIrrigationEventGroups500,
>(
	params?: ListIrrigationEventGroupsParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listIrrigationEventGroups>>,
				TError,
				TData
			>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof listIrrigationEventGroups>>,
					TError,
					Awaited<ReturnType<typeof listIrrigationEventGroups>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListIrrigationEventGroups<
	TData = Awaited<ReturnType<typeof listIrrigationEventGroups>>,
	TError = ListIrrigationEventGroups400 | ListIrrigationEventGroups500,
>(
	params?: ListIrrigationEventGroupsParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listIrrigationEventGroups>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List irrigation event groups for the authenticated user, optionally filtered by name or source
 */

export function useListIrrigationEventGroups<
	TData = Awaited<ReturnType<typeof listIrrigationEventGroups>>,
	TError = ListIrrigationEventGroups400 | ListIrrigationEventGroups500,
>(
	params?: ListIrrigationEventGroupsParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listIrrigationEventGroups>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
} {
	const queryOptions = getListIrrigationEventGroupsQueryOptions(
		params,
		options,
	);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> };

	return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List irrigation event groups for the authenticated user, optionally filtered by name or source
 */
export const useSetListIrrigationEventGroupsQueryData = () => {
	const queryClient = useQueryClient();
	return (
		params: ListIrrigationEventGroupsParams | undefined,
		updater:
			| Awaited<ReturnType<typeof listIrrigationEventGroups>>
			| undefined
			| ((
					old:
						| Awaited<ReturnType<typeof listIrrigationEventGroups>>
						| undefined,
			  ) => Awaited<ReturnType<typeof listIrrigationEventGroups>> | undefined),
	) => {
		queryClient.setQueriesData<
			Awaited<ReturnType<typeof listIrrigationEventGroups>>
		>({ queryKey: getListIrrigationEventGroupsQueryKey(params) }, updater);
	};
};

/**
 * @summary List irrigation event groups for the authenticated user, optionally filtered by name or source
 */
export const useGetListIrrigationEventGroupsQueryData = () => {
	const queryClient = useQueryClient();
	return (params?: ListIrrigationEventGroupsParams) =>
		queryClient.getQueryData<
			Awaited<ReturnType<typeof listIrrigationEventGroups>>
		>(getListIrrigationEventGroupsQueryKey(params));
};

export const getGetIrrigationEventGroupUrl = (
	irrigationEventGroupId: string,
) => {
	return `/irrigation-event-groups/${irrigationEventGroupId}`;
};

/**
 * @summary Get a single irrigation event group by ID
 */
export const getIrrigationEventGroup = async (
	irrigationEventGroupId: string,
	options?: RequestInit,
): Promise<CommandGroup> => {
	return customFetch<CommandGroup>(
		getGetIrrigationEventGroupUrl(irrigationEventGroupId),
		{
			...options,
			method: "GET",
		},
	);
};

export const getGetIrrigationEventGroupQueryKey = (
	irrigationEventGroupId: string,
) => {
	return ["irrigation-event-groups", irrigationEventGroupId] as const;
};

export const getGetIrrigationEventGroupQueryOptions = <
	TData = Awaited<ReturnType<typeof getIrrigationEventGroup>>,
	TError =
		| GetIrrigationEventGroup400
		| GetIrrigationEventGroup404
		| GetIrrigationEventGroup500,
>(
	irrigationEventGroupId: string,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getIrrigationEventGroup>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ??
		getGetIrrigationEventGroupQueryKey(irrigationEventGroupId);

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof getIrrigationEventGroup>>
	> = ({ signal }) =>
		getIrrigationEventGroup(irrigationEventGroupId, {
			signal,
			...requestOptions,
		});

	return {
		queryKey,
		queryFn,
		enabled:
			irrigationEventGroupId !== null && irrigationEventGroupId !== undefined,
		...queryOptions,
	} as UseQueryOptions<
		Awaited<ReturnType<typeof getIrrigationEventGroup>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetIrrigationEventGroupQueryResult = NonNullable<
	Awaited<ReturnType<typeof getIrrigationEventGroup>>
>;
export type GetIrrigationEventGroupQueryError =
	| GetIrrigationEventGroup400
	| GetIrrigationEventGroup404
	| GetIrrigationEventGroup500;

export function useGetIrrigationEventGroup<
	TData = Awaited<ReturnType<typeof getIrrigationEventGroup>>,
	TError =
		| GetIrrigationEventGroup400
		| GetIrrigationEventGroup404
		| GetIrrigationEventGroup500,
>(
	irrigationEventGroupId: string,
	options: {
		query: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getIrrigationEventGroup>>,
				TError,
				TData
			>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof getIrrigationEventGroup>>,
					TError,
					Awaited<ReturnType<typeof getIrrigationEventGroup>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetIrrigationEventGroup<
	TData = Awaited<ReturnType<typeof getIrrigationEventGroup>>,
	TError =
		| GetIrrigationEventGroup400
		| GetIrrigationEventGroup404
		| GetIrrigationEventGroup500,
>(
	irrigationEventGroupId: string,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getIrrigationEventGroup>>,
				TError,
				TData
			>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof getIrrigationEventGroup>>,
					TError,
					Awaited<ReturnType<typeof getIrrigationEventGroup>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetIrrigationEventGroup<
	TData = Awaited<ReturnType<typeof getIrrigationEventGroup>>,
	TError =
		| GetIrrigationEventGroup400
		| GetIrrigationEventGroup404
		| GetIrrigationEventGroup500,
>(
	irrigationEventGroupId: string,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getIrrigationEventGroup>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get a single irrigation event group by ID
 */

export function useGetIrrigationEventGroup<
	TData = Awaited<ReturnType<typeof getIrrigationEventGroup>>,
	TError =
		| GetIrrigationEventGroup400
		| GetIrrigationEventGroup404
		| GetIrrigationEventGroup500,
>(
	irrigationEventGroupId: string,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getIrrigationEventGroup>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
} {
	const queryOptions = getGetIrrigationEventGroupQueryOptions(
		irrigationEventGroupId,
		options,
	);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> };

	return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get a single irrigation event group by ID
 */
export const useSetGetIrrigationEventGroupQueryData = () => {
	const queryClient = useQueryClient();
	return (
		irrigationEventGroupId: string,
		updater:
			| Awaited<ReturnType<typeof getIrrigationEventGroup>>
			| undefined
			| ((
					old: Awaited<ReturnType<typeof getIrrigationEventGroup>> | undefined,
			  ) => Awaited<ReturnType<typeof getIrrigationEventGroup>> | undefined),
	) => {
		queryClient.setQueriesData<
			Awaited<ReturnType<typeof getIrrigationEventGroup>>
		>(
			{ queryKey: getGetIrrigationEventGroupQueryKey(irrigationEventGroupId) },
			updater,
		);
	};
};

/**
 * @summary Get a single irrigation event group by ID
 */
export const useGetGetIrrigationEventGroupQueryData = () => {
	const queryClient = useQueryClient();
	return (irrigationEventGroupId: string) =>
		queryClient.getQueryData<
			Awaited<ReturnType<typeof getIrrigationEventGroup>>
		>(getGetIrrigationEventGroupQueryKey(irrigationEventGroupId));
};

export const getDeleteIrrigationEventGroupUrl = (
	irrigationEventGroupId: string,
) => {
	return `/irrigation-event-groups/${irrigationEventGroupId}`;
};

/**
 * @summary Delete a command group and all its associated irrigation events
 */
export const deleteIrrigationEventGroup = async (
	irrigationEventGroupId: string,
	options?: RequestInit,
): Promise<CommandGroup> => {
	return customFetch<CommandGroup>(
		getDeleteIrrigationEventGroupUrl(irrigationEventGroupId),
		{
			...options,
			method: "DELETE",
		},
	);
};

export const getDeleteIrrigationEventGroupMutationOptions = <
	TError =
		| DeleteIrrigationEventGroup400
		| DeleteIrrigationEventGroup404
		| DeleteIrrigationEventGroup500,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof deleteIrrigationEventGroup>>,
		TError,
		{ irrigationEventGroupId: string },
		TContext
	>;
	request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof deleteIrrigationEventGroup>>,
	TError,
	{ irrigationEventGroupId: string },
	TContext
> => {
	const mutationKey = ["deleteIrrigationEventGroup"];
	const { mutation: mutationOptions, request: requestOptions } = options
		? options.mutation &&
			"mutationKey" in options.mutation &&
			options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey }, request: undefined };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof deleteIrrigationEventGroup>>,
		{ irrigationEventGroupId: string }
	> = (props) => {
		const { irrigationEventGroupId } = props ?? {};

		return deleteIrrigationEventGroup(irrigationEventGroupId, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type DeleteIrrigationEventGroupMutationResult = NonNullable<
	Awaited<ReturnType<typeof deleteIrrigationEventGroup>>
>;

export type DeleteIrrigationEventGroupMutationError =
	| DeleteIrrigationEventGroup400
	| DeleteIrrigationEventGroup404
	| DeleteIrrigationEventGroup500;

/**
 * @summary Delete a command group and all its associated irrigation events
 */
export const useDeleteIrrigationEventGroup = <
	TError =
		| DeleteIrrigationEventGroup400
		| DeleteIrrigationEventGroup404
		| DeleteIrrigationEventGroup500,
	TContext = unknown,
>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof deleteIrrigationEventGroup>>,
			TError,
			{ irrigationEventGroupId: string },
			TContext
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseMutationResult<
	Awaited<ReturnType<typeof deleteIrrigationEventGroup>>,
	TError,
	{ irrigationEventGroupId: string },
	TContext
> => {
	return useMutation(
		getDeleteIrrigationEventGroupMutationOptions(options),
		queryClient,
	);
};
